/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface UseCaseName
 */
export interface UseCaseName {
  /**
   *
   * @type {number}
   * @memberof UseCaseName
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof UseCaseName
   */
  name: string;
}

/**
 * Check if a given object implements the UseCaseName interface.
 */
export function instanceOfUseCaseName(value: object): value is UseCaseName {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function UseCaseNameFromJSON(json: any): UseCaseName {
  return UseCaseNameFromJSONTyped(json, false);
}

export function UseCaseNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): UseCaseName {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
  };
}

export function UseCaseNameToJSON(value?: Omit<UseCaseName, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
